import React from 'react'
import Collection from '../common/collection'

function CollectionL({ props }) {
  return (
    <Collection
      alt="Cera"
      src={[
        'https://volverse-negro-daniel.s3.amazonaws.com/images/11.+cera28.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/11.+cera29.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/11.+cera30.jpg',
        'https://volverse-negro-daniel.s3.amazonaws.com/images/11.+cera7.jpg',
      ]}
    />
  )
}


export default CollectionL
